<template>
  <div class="details-page">
    <h3 class="article_title">{{title}}</h3>
    <div class="article-sub">
      <div @click="openSub">{{refname}}</div>
      <div>{{getFormatDate()}}</div>
      <div class="lineDiv"></div>
      <div>阅读：{{viewcount}}</div>
      <div class="lineDiv"></div>
      <div>转发：{{fwdcount}}</div>
    </div>
    <div v-if="changeMe" class="changeBox" style="display:flex;justify-content:flex-end;width:100%;">
      <div class="changeHead" v-if="!isGsc" @click="checkUser($event)">
        <img src="./img/change.png" alt="">
        <span>换成我的</span>
      </div>
    </div>
    <div v-else style="width:100%;height:14px;"></div>
    <div class="business_card" v-if="!isGsc" :class="[changeMe ? 'bgOne' : 'bgTwo']">
      <div class="user_info">
        <div class="avatar">
          <img :src="cardInfo.headerImg" alt />
        </div>
        <div class="info">
          <div class="name">{{cardInfo.name}}</div>
          <div class="phone">服务领域：{{lblName}}</div>
        </div>
      </div>
      <div class="btnBox">
        <div class="look" @click="goToCard">查看详情</div>
      </div>
    </div>
    <div class="article_content" v-html="content"></div>
    <!-- 原文链接/免责声明 -->
    <div class="article_statement">
      <div class="link" @click="openLink">原文链接</div>
      <div class="statement" @click="openState"><span>免责声明</span><img src="./img/open.png" alt=""></div>
    </div>

    <div class="statement_content" v-if="openStatement">
      <p>本文内容编辑整理均来源于网络，版权归原作者所有，如有涉及侵权，请及时联系我们，我们会立即删除，特此声明。</p>
      <div class="btn" @click="showSheet = true">
        <img src="./img/complaint.png" alt="">
        <span>投诉</span>
      </div>
    </div>
    <van-action-sheet
      v-model="showSheet"
      :round=false
      :actions="actions"
      @select="complaint"
      cancel-text="取消"
      description="问题内容"
      close-on-click-action
    />
    <!-- <div class="bot_btnBox"> -->
      <!-- <div @click="showShare" class="copyBtn"><div><img src="./img/share.png"></div><div>复制分享配文</div></div> -->
      <!-- <div @click="openSub" class="buttomBtn"><div><img src="./img/card.png"></div><div>定制专属名片</div></div> -->
    <!-- </div> -->
    <!-- <div v-if="(showLongBtn=='y'&&!showCard)||(showLongBtn=='n'&&!showCard)" class="bot_btnBox"> -->
      <!-- <div @click="openSub" class="longBtn"><div><img src="./img/card.png"></div><div>定制专属名片</div></div> -->
    <!-- </div> -->
    <div class="bot_btnBox" v-if="!isGsc">
      <div @click="showShare" class="longBtn"><div><img src="./img/share0.png"></div><div>复制分享配文</div></div>
    </div>
    <van-overlay :show="showCode" @click="showCode = false" >
        <div class="codeBox">
          <p class="topText"><van-icon name="passed" />还差一步即可完成</p>
          <img src="./img/code.png" alt="">
          <p class="midleText">长按二维码关注</p>
          <p class="botText">可以获得客户线索和更多功能</p>
        </div>
    </van-overlay>
    <van-overlay :show="showShareTip" @click="showShareTip = false">
      <img style="width:100px;height:100px;position:absolute;right:30px;top:4px" src="./img/arrow.png" alt="">
      <P style="text-align:center;position:absolute;top:120px;right:20%;color:#fff;font-size:16px;">已复制朋友圈配文<br>点击右上角转发分享</P>
      <div class="matchTitle">
        <p>朋友圈配文</p>
        <div class="content">
          {{artcsummary ? artcsummary : '暂无配文'}}
        </div>
        <p>以上文字已复制，请在分享时使用</p>
      </div>
    </van-overlay>
    <!-- 二维码 -->
    <van-overlay :show="showKfInfo" @click="showKfInfo = false">
      <div class="wrapper">
        <img class="block" src="./img/Ewm.jpg" alt="">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { Toast,Dialog,ActionSheet } from "vant";
export default {
  name: "articleDetails",
  data() {
    return {
      changeMe:true,
      isGsc:false,
      articleId: "",
      title: "",
      refname: "",
      reflink:'',
      viewcount:0,
      fwdcount:0,
      artctype:'',
      publishDate: "",
      content: "",
      baseUrl: "",
      shareLink: "",
      shareImg: "",
      cardInfo: "",
      openId: "",
      firstTransferPerson: "",
      lastTransferPerson: "",
      customerName: "",
      customerPhoneNumber: "",
      showCode:false,
      showShareTip:false,
      headerImg:'',
      unionid:'',
      lblName:'',
      showKfInfo:false,
      artcsummary:'',
      showLongBtn:'y',
      showCard:false,
      isReg:false,
      openStatement:false,
      showSheet:false,
      articleLink:false,
      actions: [
        { id:0, name: '举报非此品牌内容',className:'one'},
        { id:1, name: '举报文章内容质量差',className:'one'},
        { id:2, name: '涉及欺诈、色情、版权问题',className:'one'},
      ],
      isAdmin:false
    };
  },
  computed: {
    transid: () => {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    }
  },
  created() {
    var that=this;
      if(sessionStorage.getItem('firstTransferPerson')){
        var activeData = {
            transId: that.transid,
            timeFlag: that.getTimeStamp(2),
            actionType: "visit",
            action: "ACT6",
            userId: sessionStorage.getItem('unionid')?sessionStorage.getItem('unionid'):sessionStorage.getItem('openId'),
            unionid:sessionStorage.getItem('unionid'),
            funcId: that.getUrlParams('articleId'),
            url: window.location.href,
            fromUrl: document.referrer,
            productId: that.getUrlParams('type'),
            buttonId: sessionStorage.getItem('firstTransferPerson'),
            accessType: "V1",
          };
      that.submitUserActive(activeData);
      that.submitVisitedTimes();
    }
  },
  mounted() {
    var that = this;
    let gscLen = Object.keys(this.$route.query).length;
    if(gscLen<=2 && this.getUrlParams('articleId')){
      this.articleId =this.$route.query.articleId;
      this.isGsc = true;
      this.getDetails();
    }else{
      that.checkPower();
      this.unionid=sessionStorage.getItem('unionid')

      if(!this.getUrlParams("firstTransferPerson")){
        this.changeMe = false
      }else{
        if(this.unionid == this.getUrlParams("firstTransferPerson")){
          this.changeMe = false
        }
      }
      that.showLongBtn=this.$route.query.showLongBtn;
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.cancel, false);
      }
    }
  },
    destroyed(){
      window.removeEventListener('popstate', this.cancel, false);
    },
  methods: {
    checkPower() {
      let that=this;
      this.$post("checkAuthority", {
        unionid: this.getUrlParams('firstTransferPerson')
      }).then(res => {
        if (res) {
          if (res.data) {
            this.isAdmin = true;

          }
          //  else {

          // }
            this.articleId =this.$route.query.articleId ||sessionStorage.getItem("articleId");
            this.firstTransferPerson = this.getUrlParams("firstTransferPerson")?(this.isAdmin?sessionStorage.getItem('unionid'):this.getUrlParams("firstTransferPerson")):sessionStorage.getItem("unionid");
            this.lastTransferPerson =  this.getUrlParams("lastTransferPerson");
            this.first_openid = this.getUrlParams('first_openid')?(this.isAdmin?sessionStorage.getItem('openId'):this.getUrlParams('first_openid')):sessionStorage.getItem('openId')
            this.getCard(this.firstTransferPerson);
            if (location.hostname === "zf.dtfcloud.com") {
                  that.baseUrl = "https://zf.dtfcloud.com/";
                  that.appId = "wxae0168c583647722";
                } else {
                  that.baseUrl = "https://jzt.dtfcloud.com/";
                  that.appId = "wxae0168c583647722";
            }
            let url =
              that.baseUrl +
              "article/index.html#/articleDetails?articleId=" +
              that.articleId +
              "&firstTransferPerson=" +
              that.firstTransferPerson +
              "&lastTransferPerson=" +
              sessionStorage.getItem("unionid")+'&type=ART&first_openid='+sessionStorage.getItem('openId');
              that.shareLink =
              that.baseUrl +
              "article/static/html/redirect.html?app3Redirect=" +
              encodeURIComponent(url);
            setTimeout(function(){
                sessionStorage.setItem("articleId", that.articleId);
                that.openId = sessionStorage.getItem("openId")||that.$route.query.openId ;
                that.getDetails();
            },500);
        }
      });
    },
  showShare(){
    this.showShareTip = true;
    this.copyText()
  },
  complaint(e){
    this.$post('insertComplaints',{
      artcid: this.articleId,
      artctype: this.artctype,
      userid: this.unionid,
      complain:e.name
    }).then(res=>{
    })
    Toast('举报成功')
  },
  openLink(){
    window.location.href = this.reflink
  },
  openState(){
    this.openStatement = !this.openStatement
    this.articleLink = false
  },
  openSub(){
    this.showKfInfo = true
  },
  // 主要获取服务领域
  getServLabelList(id){
    this.$get('getCard',{
      id,
      type:'1'
    }).then(res=>{
      if (res.responseResult.responseCode === "0000") {
        if(res.agentCardReq){
          const lbl = res.agentCardReq.servLabelList.map(item=>{
            return item.lblName
          })
          this.lblName = lbl.toString();
        }
      }
    })
  },
  cancel: function() {
        if(this.$route.query.canBack!="y"&&this.$route.name=='articleDetails'){
         window.WeixinJSBridge.call('closeWindow')
        }
        else{
            this.$router.go(-1);
        }
    },
    getUrlParams: function(paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function() {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    getDetails() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      that.$get("articleDetails", { artcId: that.articleId }).then(res => {
        Toast.clear();
        if (res.responseResult.responseCode === "0000") {
          that.title = res.aisArticle.title;
          this.refname = res.aisArticle.refname;
          this.viewcount=res.aisArticle.viewcount;
          this.fwdcount=res.aisArticle.fwdcount;
          this.publishDate = res.aisArticle.pubdate;
          this.content = res.aisArticle.content;
          // this.share(this.title,'',this.shareLink,this.shareImg)
          that.title = res.aisArticle.title;
          that.refname = res.aisArticle.refname;
          that.reflink = res.aisArticle.reflink;
          that.publishDate = res.aisArticle.pubdate;
          that.content = res.aisArticle.content;
          that.shareImg=res.aisArticle.coverlink;
          that.artcsummary=res.aisArticle.friendsummary;
          that.artctype = res.aisArticle.artctype;
          that.share(that.title, that.artcsummary, that.shareLink, res.aisArticle.coverlink);
        } else {
          Toast(res.responseResult.responseMsg);
        }
      });
    },
    //获取微信头像
    getArticleUserInfo(obj){
      var that=this;
        that.$post("queryMyMessage", { phoneNumber:obj.tel,openId:obj.openId }).then(res => {
        if (res) {
          that.headerImg = res.result.headImgUrl;
        } else {
          Toast('请求失败');
        }
      });
    },
    getFormatDate() {
      let publishDate = "";
        const date = new Date(Date.parse(new Date()));
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          date.getDate() < 10
            ? "0" + date.getDate() + " "
            : date.getDate();
        publishDate = Y + M + D;
      return publishDate;
    },
    getCard(id) {
      let that = this;
      that.getServLabelList(that.first_openid)
      that
        .$get("getCardByUnionid", {
          unionid: this.firstTransferPerson ? this.firstTransferPerson : id,
        })
        .then(res => {
          if (res.ret === "00000") {
            if(res.data!=null){
                that.cardInfo = res.data;
                that.showCard=true;
            }else{
                that.cardInfo={
                  name:'i致富',
                  tel:'',
                  headerImg:require('./img/bin.png')
                }
            }

          }
        });
    },
    goToCard() {
      if(this.unionid==this.firstTransferPerson){
        // window.location.href = this.baseUrl + "centre/index.html#/myCard?first_openId=" + this.firstTransferPerson;
        window.location.href =
          this.baseUrl +
          "centre/index.html#/myCardEdit?openId=" +
          (this.firstTransferPerson ? this.firstTransferPerson : sessionStorage.getItem('unionid')) +
          "&name=" +
          this.cardInfo.name+
          "&type=ARTB&funcId="+this.articleId+
          "&userId="+sessionStorage.getItem('unionid') + '&first_openId=' + this.openId;
      }else{
        window.location.href =
          this.baseUrl +
          "centre/index.html#/myCardView?openId=" +
          (this.firstTransferPerson ? this.firstTransferPerson : sessionStorage.getItem('unionid')) +
          "&name=" +
          this.cardInfo.name+
          "&type=ARTB&funcId="+this.articleId+
          "&userId="+sessionStorage.getItem('unionid') + '&first_openId=' + this.first_openid;
      }
    },
    chekCard(){
      if(this.firstTransferPerson&&this.firstTransferPerson!=sessionStorage.getItem('unionid')){
        window.location.href =
        this.baseUrl +
        "centre/index.html#/myCard?openId=" +this.firstTransferPerson +'&first_openid='+sessionStorage.getItem('openId');
      }
    },

    checkAuth() {
      var that=this;
      that.$post("authentication", {
        openid: that.openId,
        unionid:sessionStorage.getItem('unionid'),
        id: "3"
      })
      .then(res => {
        if (res.data == 0) {
          that.firstTransferPerson=sessionStorage.getItem('unionid');
          that.getCard(); //拥有权限
          that.changeMe = false;
          let url =that.baseUrl + "article/index.html#/articleDetails?articleId=" + that.articleId + "&firstTransferPerson=" + that.firstTransferPerson + "&lastTransferPerson=" +sessionStorage.getItem('unionid');
            that.shareLink =that.baseUrl + "article/static/html/redirect.html?app3Redirect=" + encodeURIComponent(url);
            that.share(that.title, that.artcsummary,that.shareLink, that.shareImg);

        } else if (res.data == 1) {

            let cardUrl='';
            Toast('查询到您未设置名片，稍后将跳转到名片设置页')
          if (location.hostname === "zf.dtfcloud.com") {
            cardUrl =
              "https://zf.dtfcloud.com/centre/index.html#/myCardEdit?openId=" + sessionStorage.getItem('openId')+'&unionid='+sessionStorage.getItem('unionid') + '&isReg=no';
          } else {
            cardUrl =
              "https://jzt.dtfcloud.com/centre/index.html#/myCardEdit?openId=" +sessionStorage.getItem('openId')+'&unionid='+sessionStorage.getItem('unionid') + '&isReg=no';
          }
          setTimeout(function(){
             window.location.href = cardUrl;              // that.showCode=true;
          },1500)
        }
      })
      .catch(err => {
      });
    },
    //验证是否是注册用户
    checkUser(e) {
      e.stopPropagation();
      this.$get("checkUser",
      {
      openId: sessionStorage.getItem('openId'),
      nikeName: sessionStorage.getItem('nickname')
      // openId:sessionStorage.getItem('openId'),
      // nikeName:'HLH'
        }
      ).then(res => {
        if (res.ret == "00000") {
          //已注册
          this.isReg=true
          this.checkAuth()
        }
        if (res.ret == "200009") {
          //用户未注册
          let registerUrl='';
          this.isReg = false
          Toast('你还未注册U蜂巢，即将跳转到注册页面')

          if (location.hostname === "zf.dtfcloud.com") {
            registerUrl =
              "https://dtfcloud.com/xz-data-admin/#/register?openId=" + sessionStorage.getItem('openId')+'&unionid='+sessionStorage.getItem('unionid') + '&isReg=no';
          } else {
            registerUrl =
              "https://jzt.dtfcloud.com/xz-data-admin/#/register?openId=" +sessionStorage.getItem('openId')+'&unionid='+sessionStorage.getItem('unionid') + '&isReg=no';
          }
          setTimeout(function(){
            window.location.href = registerUrl;
          },1500)
        }
        if (res.ret == "200008") {
          // alert("您还未注册");
          this.isReg=false
        }
      });
    },
    //复制文本
    copyText(){
      if(this.artcsummary){
        this.$copyText(this.artcsummary).then(res => {
              Toast('朋友圈配文已复制')
        }).catch(err => {

        })
      }

    },
    share(title, desc, shareLink, shareImg) {
      let that = this;
      let url = location.href.split("#")[0];
      that.$get("articleShare", { url: url }).then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: [
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
            "hideMenuItems"
          ] // 必填，需要使用的JS接口列表
        });
        wx.ready(function() {
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            success: function() {
              // 用户确认分享后执行的回调函数
              that.$post("articleShareSuccess", {
                temp:0,
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.firstTransferPerson,
                lastTransferPerson: sessionStorage.getItem("unionid")?sessionStorage.getItem("unionid"):sessionStorage.getItem('openId'),
                activityType: "ART",
                agtid: sessionStorage.getItem("unionid")?sessionStorage.getItem("unionid"):sessionStorage.getItem('openId'),
                unionid:sessionStorage.getItem("unionid"),
                // wechatNumber: sessionStorage.getItem("openId")
                // wechatNumber: that.firstTransferPerson!=sessionStorage.getItem("unionid")?( sessionStorage.getItem("unionid")?sessionStorage.getItem("unionid"):sessionStorage.getItem('openId')):'',
                wechatNumber:sessionStorage.getItem('unionid')!=that.firstTransferPerson
                  ? that.getUrlParams("lastTransferPerson")
                  : "", //上次转发人
              });
            },
            cancel: function() {}
          });
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标
            success: function() {
              // alert(_ok)
              // 用户确认分享后执行的回调函数
                that.$post("articleShareSuccess", {
                temp:0 || '0',
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.firstTransferPerson,
                lastTransferPerson:  sessionStorage.getItem("unionid")?sessionStorage.getItem("unionid"):sessionStorage.getItem('openId'),
                activityType: "ART",
                agtid:  sessionStorage.getItem("unionid")?sessionStorage.getItem("unionid"):sessionStorage.getItem('openId'),
                unionid:sessionStorage.getItem("unionid"),
                wechatNumber:sessionStorage.getItem('unionid')!=that.firstTransferPerson
                  ? that.getUrlParams("lastTransferPerson")
                  : "", //上次转发人

                // wechatNumber: that.firstTransferPerson!=sessionStorage.getItem("unionid")?( sessionStorage.getItem("unionid")?sessionStorage.getItem("unionid"):sessionStorage.getItem('openId')):'',
              });
            }
          });
        });
      });
    },
    getTimeStamp: function(format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      //精确到天
      if (format == 1) {
        time = year + "-" + month + "-" + date;
      }
      //精确到分
      else if (format == 2) {
        time =
          year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      }
      return time;
    },
    //统计时长
    submitVisitedTimes() {
      let that = this;
      let data = {
        transId  : that.transid,
        viewDuration  : 5
      };
      that.$post("subViewduration", data).then(res => {
        if (res.ret == "00000") {
          setTimeout(function(){that.submitVisitedTimes()},5000);
        }
      });
    },
    //
    submitUserActive: function(obj) {
      let that = this;
      that.$post("userActive", JSON.stringify(obj)).then(res => {
        // if (res.ret === "00000") {
        // }
      });
      // alert('提交成功')
    },
    // 生成唯一ID
    getTransId: function() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    }
  }
};
</script>

<style lang="less" scoped>
.matchTitle{
  width: 86%;
  position: absolute;
  bottom: 20px;
  left: 50%;
  bottom: 20px;
  border-radius: 16px;
  padding: 16px 12px;
  transform: translate(-50%,0);
  background: #fff;
  text-align: center;
  p:nth-child(1){
    font-size: 16px;
    color: black;
    font-weight: bold;
  }
  .content{
    background: #F8F8F8;
    width: 100%;
    min-height: 50px;
    font-size: 14px;
    line-height: 2;
    color: #383838;
    padding: 16px 12px;
    margin: 10px 0;
    // border-radius: 4px;
  }
  p:nth-child(3){
    font-size: 12px;
    color: #858585;
  }
}
.article_link{
  width: 100%;
  color: #95c6f8;
  font-size: 12px;
  line-height: 1.6;
  padding: 0 10px;
  word-wrap: break-word;
}
.van-action-sheet__gap{
  height: 2px;
}
.van-action-sheet__description{
  color: #383838;
  font-size: 16px;
  font-weight: bold;
}
.one{
  color: #383838;
  font-size: 14px;
}
.article_statement{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 10px;
  padding: 0 10px;
  .link{
    font-size: 12px;
    line-height: 12px;
    color: #458AD1;
  }
  .statement{
    display: flex;
    align-items: center;
    span{
      font-size: 12px;
      line-height: 12px;
      color: #D0D0D0;
    }
    img{
      width: 20px;
      height: 20px;
    }
  }
}
.statement_content{
  text-align: center;
  padding: 0 10px;
  p{
    font-size: 12px;
    line-height: 1.6;
    color: #D8D8D8;
  }
  .btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    border: 2px solid #D8D8D8;
    margin: 20px auto;
    img{
      width: 20px;height: 20px;
    }
    span{
      color: #ccc8c8;
      font-size: 12px;
      line-height: 12px;

    }
  }
}
.bot_btnBox{
  display: flex;
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 100%;
  justify-content: space-around;
  .buttomBtn,.copyBtn{
    text-align: center;
    width: 128px;
    height: 38px;
    line-height: 38px;
    color: #fff;
    background: linear-gradient(270deg, #FF4832 0%, #FFA041 100%);
    box-shadow: 0px 3px 6px #f1b1b1;
    opacity: 1;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;

    div{
      img{
        width: 16px;
        position: relative;
        top:-2px;
        left: -5px;
        padding-top: 4px;
        vertical-align: middle;
      }
    }
  }
  .longBtn{
    text-align: center;
    width: 350px;
    height: 38px;
    line-height: 38px;
    color: #fff;
    background: linear-gradient(270deg, #FF4832 0%, #FFA041 100%);
    box-shadow: 0px 3px 6px #f1b1b1;
    opacity: 1;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      img{
        width: 16px;
        position: relative;
        top:-2px;
        left: -5px;
        padding-top: 4px;
        vertical-align: middle;
      }
    }
  }
}

.details-page {
  padding: 0 15px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  overflow-x: hidden;
  padding-bottom: 60px;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 260px;
      height: 334px;
      background-color: #fff;
      border-radius: 4px;
    }
  }
  .article_title {
    padding: 10px 0;
    font-size: 18px;
    text-align: left;
  }
  .changeBox{
    position: relative;
    .changeHead{
      margin-top: 4px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      // border:1px solid red;
      background: url(./img/changeMe.png) no-repeat;
      object-fit: contain;
      width: 120px;
      height: 22px;
      // border: 1px solid skyblue;
      border-radius: 0 12px 0 0 ;
      padding: 4px 12px 4px 0;
      img{
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      span{
        color: #fff;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
  .article-sub {
    // margin-bottom: 20px;
    font-size: 13px;
    line-height: 18px;
    display: flex;
    color: #a6a6a6;
    div{
      margin-right: 4px;
      white-space:nowrap ;
    }
    div.lineDiv{
      height: 10px;
      width: 1px;
      margin-top: 4px;
      background: #a6a6a6;
    }
    div:nth-child(1) {
        color: #2b6a87;
      }
  }
  .bgOne{
    background: url(./img/bg.png) no-repeat;
  }
  .bgTwo{
    background: url(./img/bgbg.png) no-repeat;
  }
  .business_card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
    margin-bottom: 20px;
    // background: url(./img/bg.png) no-repeat;
    background-size:100% 100%;
    padding: 16px 14px;
    .user_info {
      display: flex;
      align-items: center;
      .avatar {
        margin-right: 10px;
        overflow: hidden;
        flex-shrink: 0;
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 2px solid #eee;
        }
      }
      .info {
        color: #fff;
        .name {
          font-size:15px;
          line-height: 15px;
          margin-bottom: 6px;
          font-weight: bold;
        }
        .phone {
          font-size: 13px;
          line-height: 1.3;
        }
      }
    }
    .btnBox{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      .look {
        width: 80px;
        padding: 4px 0;
        text-align: center;
        background: #fff;
        border-radius: 16px;
        font-size: 14px;
        color: #1f90fd;
      }
      img{
        width: 20px;
        height: 20px;
      }
    }
  }

  .article_content p {
    margin: 16px 0;
  }
  .van-overlay{
      -webkit-touch-callout:none;
      -webkit-user-select:none;
      -khtml-user-select:none;
      -moz-user-select:none;
      -ms-user-select:none;
      user-select:none;
      .codeBox{
        width: 220px;
        height: 238px;
        margin: 160px auto;
        background: #fff;
        border-radius: 8px;
        padding: 30px;
        text-align: center;
          img{
        width: 108px;
        height: 108px;
        margin: 0px auto;
      }
      .topText{
        color: #3176FF;
        font-size: 12px;
        margin-bottom: 13px;
      }
      .midleText{
        color: #FF4A4A;
        font-size: 14px;
        margin: 10px 0;

      }
      .botText{
        color: #999999;
        font-size: 11px;
      }
      }
      .tipBox{
        position: absolute;
        width: 100%;
        left: 0;
        bottom:0;
        background: #fff;
        padding-bottom: 64px;
        h2{
          color: #1A1A1A;
          text-align: center;
          line-height: 50px;
          font-size: 16px;
        }
        .closeBtn{
          width: 40px;
          height: 40x;
          position: absolute;
          right: 4px;
          top: 0;
          img{
            width: 10px;
            margin: 15px auto;
          }
        }
        p{
          color: #1A1A1A;
          padding: 0 16px;
          font-size: 12px;

        }
        .bot_content{
          position: absolute;
          bottom: 16px;
          left: 0;
          width: 100%;
          display: flex;
          justify-content: space-between;
          p{
            padding: 0;
            line-height: 31px;
            color: #FF6927;
            margin-left: 16px;
          }
          div{
            margin-right: 16px;
            width: 72px;
            height: 31px;
            background: linear-gradient(270deg, #FF4C32 0%, #FF983F 100%);
            opacity: 1;
            border-radius: 15px;
            line-height: 31px;
            text-align: center;
            color: #fff;
          }

        }
      }



  }
}
</style>
